// src/rtkQuery/hooks/useLoginFormSubmission.ts
import type { LoginFormSchema } from "@/validation-schemas/login-form-schemas";
import { AUTH_MESSAGES } from "@/rtkQuery/config/authApi.config";
import { useAuthService } from "./useAuthService";

export const useLoginFormSubmission = () => {
    const {
        login,
        loginIsLoading: isLoading,
        loginIsSuccess: isSuccess,
        loginIsError: isError,
        loginError,
        loginStatus,
        loginResponse,
    } = useAuthService();

    const submitLoginForm = async (formData: LoginFormSchema) => {
        try {
            const result = await login(formData, { success: AUTH_MESSAGES.LOGIN_SUCCESS });

            if (result.success) {
                return result;
            } else {
                console.error(result.error)
            }
        } catch (err: any) {
            console.error(err)
        }
    };

    return {
        submitLoginForm,
        isLoading,
        isSuccess,
        isError,
        error: loginError,
        status: loginStatus,
        data: loginResponse,
    };
};
